import type { Layout } from '../../types/layout'
import { LAYOUT_KEYS } from '../../types/layout'
import { avatarBlueprint } from './avatar'
import { bigTitleBlueprint } from './bigTitle'
import { blockBlueprint } from './block'
import { chatboxBlueprint } from './chatbox'
import { edgyBlueprint } from './edgy'
import { framedBlueprint } from './framed'
import { postcardBlueprint } from './postcard'
import { scriptLargeBlueprint } from './scriptLarge'
import { scriptSmallBlueprint } from './scriptSmall'
import { selfPortraitBlueprint } from './selfPortrait'
import { captionsBlueprint, memeBlueprint, translucentBlueprint } from './video'
import type { TemplateBlueprint } from './types'

export * from './types'

/** One blueprint per v1 layout (#77): the template a layout became. */
export const BLUEPRINTS: Record<Layout, TemplateBlueprint> = {
  avatar: avatarBlueprint,
  bigTitle: bigTitleBlueprint,
  block: blockBlueprint,
  chatbox: chatboxBlueprint,
  edgy: edgyBlueprint,
  framed: framedBlueprint,
  postcard: postcardBlueprint,
  scriptLarge: scriptLargeBlueprint,
  scriptSmall: scriptSmallBlueprint,
  selfPortrait: selfPortraitBlueprint,
  captions: captionsBlueprint,
  meme: memeBlueprint,
  translucent: translucentBlueprint,
}

/** The template ids are the layout keys, in the registry's order. */
export const TEMPLATE_IDS: readonly Layout[] = LAYOUT_KEYS

export function templateKind(layout: Layout): TemplateBlueprint['kind'] {
  return BLUEPRINTS[layout].kind
}
